import React from 'react';

export interface UICircleChartSegment {
  value: number;
  percentage: number;
  color: string;
  label?: string;
}

export interface UICircleChartProps {
  segments: UICircleChartSegment[];
  size?: number;
  strokeWidth?: number;
  backgroundColor?: string;
  className?: string;
  showLabels?: boolean;
}

const UICircleChart: React.FC<UICircleChartProps> = ({
                                                       segments,
                                                       size = 104,
                                                       strokeWidth = 10,
                                                       backgroundColor = '#F4F6F8',
                                                       className = '',
                                                       showLabels = false,
                                                     }) => {
  const radius = (size - strokeWidth) / 2;
  const normalizedRadius = radius - strokeWidth * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;

  // Розраховуємо початкові позиції для кожного сегмента
  let currentOffset = 0;
  const segmentsWithOffsets = segments.map((segment) => {
    const segmentLength = (segment.percentage / 100) * circumference;
    const segmentData = {
      ...segment,
      length: segmentLength,
      offset: currentOffset,
    };
    currentOffset += segmentLength;
    return segmentData;
  });

  return (
    <div className={`UICircleChart ${className}`}>
      <svg
        height={size}
        width={size}
        style={{
          transform: 'rotate(-90deg)', // Починаємо зверху
        }}
      >
        {/* Background circle */}
        <circle
          stroke={backgroundColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
        />

        {/* Segments */}
        {segmentsWithOffsets.map((segment, index) => (
          <circle
            key={index}
            stroke={segment.color}
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={`${segment.length} ${circumference}`}
            strokeDashoffset={-segment.offset}
            strokeLinecap="butt"
            r={normalizedRadius}
            cx={size / 2}
            cy={size / 2}
          />
        ))}
      </svg>

      {/* Labels (optional) */}
      {showLabels && (
        <div className="UICircleChart__labels">
          {segments.map((segment, index) => (
            <div key={index} className="UICircleChart__label">
              <span
                className="UICircleChart__label-dot"
                style={{ backgroundColor: segment.color }}
              />
              <span className="UICircleChart__label-text">
                {segment.label}: {segment.percentage}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UICircleChart;